import $ from 'jquery';

import {
  ARCHIVED_PATH_REGEX,
  FAVORITES_PATH_REGEX,
  MY_VIDEOS_PATH_REGEX,
  SHARED_VIDEOS_PATH_REGEX,
  TEAM_VIDEOS_PATH_REGEX,
} from 'constants/regex';
import * as sentry from 'utilities/sentry';

import * as validate from 'validate';

export { getVideoURL } from '../../../shared/utilities/url';

// http://stackoverflow.com/a/901144/696130
export function getParam(name, altLocation) {
  const filteredName = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

  const urlParams = new URLSearchParams(altLocation || location.search);
  const result = urlParams.get(filteredName);

  return String(result ? result : '');
}

export function hasParam(name, source = location.search) {
  const filteredName = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

  return new URLSearchParams(source).has(filteredName);
}

export function getLinkProperties(url, cb) {
  $.ajax({
    method: 'GET',
    url: `/api/util/url-props?url=${window.encodeURIComponent(url)}`,
    success: cb,
    error() {
      cb(null);
    },
  });
}

/**
 * Starts download in same tab from a given string
 * @param {String} download - file name
 * @param {String} href - full link
 */
export function downloadLinkFromString(download, href) {
  const link = document.createElement('a');

  link.download = download;
  link.href = href;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function isMainVideosDashboard(pageUrl) {
  if (!pageUrl) {
    pageUrl = window.location;
  }

  return Boolean(
    pageUrl.pathname.match(MY_VIDEOS_PATH_REGEX) ||
      pageUrl.pathname.match(TEAM_VIDEOS_PATH_REGEX) ||
      pageUrl.pathname.match(SHARED_VIDEOS_PATH_REGEX) ||
      pageUrl.pathname.match(ARCHIVED_PATH_REGEX) ||
      pageUrl.pathname.match(FAVORITES_PATH_REGEX)
  );
}

export function isFromPublicSharePage() {
  const result = {
    fromPublicSharePage: false,
    parentLocation: null,
  };

  try {
    if (
      window.parent != null &&
      window.parent.location != null &&
      window.parent.location.pathname != null
    ) {
      result.fromPublicSharePage = new RegExp(
        '^/share/' + validate.VIDEO_ID_REGEX + '$',
        'i'
      ).test(window.parent.location.pathname);
      result.parentLocation = window.parent.location.href;
    }
  } catch (err) {
    const crossOriginError =
      err instanceof window.DOMException ||
      err.message.toLowerCase().indexOf('permission') > -1;

    if (!crossOriginError) {
      sentry.logException(err, 'error in fromPublicSharePage util', {
        iframe_referrer: document.referrer,
      });
    }
  } finally {
    if (result.parentLocation == null) {
      result.parentLocation = document.referrer;
    }
  }

  return result;
}

export function getHash() {
  return window.location.hash.substr(1);
}

export function getFilteredPathnames(path) {
  const pathnamesUnfiltered = path.split('/');
  const pathnames = pathnamesUnfiltered.filter(pathname => pathname !== '');

  return pathnames;
}

export function goToNewTab(url) {
  const win = window.open(url, '_blank');

  win.focus();
}

export function inEmbedPlayer() {
  return validate.EMBED_VIDEO_ROUTE_PATHNAME_REGEX.test(
    window.location.pathname
  );
}

const doesNotStartWith = key => p => !p.startsWith(key);

export const removeParam = window => key => {
  const { pathname, search } = window.location;
  const url = pathname + removeParamFromUrl(key, search);

  window.history.replaceState('', '', url);
};

const removeParamFromUrl = (key, search) => {
  if (search.length === 0 || search.indexOf(key) === -1) {
    return search;
  }

  const filteredParams = search
    .replace('?', '')
    .split('&')
    .filter(doesNotStartWith(key))
    .join('&');

  if (!filteredParams) {
    return '';
  }

  return `?${filteredParams}`;
};

const URL_TRAILING_PUNCTUATION = /[.,;?!:)\]}]+$/;

/**
 * Finds common punctuation characters at the end of a URL and strips them out.
 * @param {String} url - The URL to be inspected.
 * @returns {[string, string]} [trimmedUrl, trail] - A pair with the URL after
 * removing any trailing characters and the trailing characters themselves.
 */
export const splitTrailingPunctuation = url => {
  const matches = url.match(URL_TRAILING_PUNCTUATION);
  const trailing = matches !== null ? matches[0] : '';
  const trimmedUrl = trailing.length
    ? url.substring(0, url.length - trailing.length)
    : url;

  return [trimmedUrl, trailing];
};
